import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const emailLogAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.EmailLogsView],
  featureToggles: [FeatureToggle.storefrontProEmailLogs],
  minICPlatformVersion: ICPlatformVersion.r2026_06_0,
  restrictedBannersAllowed: true,
}
